<template>
  <div  class="cx-dashboard-header mb-3 cx-card-lg"
        :class="[ {'cx-dashboard-header-default': marginOverview }, 
                  {'cx-dashboard-header-nomargin': !marginOverview} ]">
    <CxMarginOverview     v-if="showRetailers && marginOverview"
                          :marginOverview="marginOverview" 
                          :theme="theme"/>

    <CxOutletOverview     v-else
                          :outletInfo="outletInfo"
                          :theme="theme" />

    <CxOverallScoreChart  :scoreInfo="scoreInfo"
                          :theme="theme" />

    <CxFocusKpiGrid       :dashboardData="dashboardData"
                          :focusKpis="focusKpis"
                          :fixFocusKpis="!showRetailers"
                          :ownerIsRetailers="showRetailers"
                          :theme="theme"
                          :threshold="threshold" />
  </div>
</template>

<script>
import CxOutletOverview from './CxOutletOverview.vue';
import CxFocusKpiGrid from './CxFocusKpiGrid.vue';
import CxMarginOverview from './Retailer/CxMarginOverview.vue';
import CxOverallScoreChart from './CxOverallScoreChart.vue';

export default {
  components: {
    CxOutletOverview, CxFocusKpiGrid, CxMarginOverview, CxOverallScoreChart
  },

  props: {
    dashboardData:          { type: Object, default: () => undefined },
    focusKpis:              { type: Object, default: () => undefined },
    marginOverview:         { type: Object, default: () => undefined },
    outletInfo:             { type: Object, default: () => undefined },
    theme:                  { type: String, default: () => 'light' },
    threshold:              { type: Array, required: true },
    scoreInfo:              { type: Object, default: () => undefined },
    showRetailers:          { type: Boolean, default: () => false },
  }
}
</script>

<style>
  .cx-dashboard-header {
    display: grid;
    grid-gap: 1rem;
    width: calc(100% - 1rem);
  }
  .cx-dashboard-header-default {
    grid-template-columns: 20% 20% 60%;
  }
  .cx-dashboard-header-nomargin {
    grid-template-columns: 20% 60% 20%;
  }
</style>
